import React, { Component } from 'react';
import * as Constants from '../../common/Global/constants';
import { matchPath,withRouter } from 'react-router-dom';
import {TopTabsLayout} from '../../common/Global/globalStyles.style';
import { getThemeSettingsVariables, hasFeatureAccess  } from '../../common/Global/commonFunctions';
import { connect } from "react-redux";
import { setUserRoleFilters } from '../../../reducers/authSlice';

let isUsers ='';
let isRoles ='';
let isDepartments ='';
let isDashboardRoles = '';
let themeColor = ``;
let themeSettings = getThemeSettingsVariables();

class UserManagementTopMenu extends Component{
    constructor(props) {
        super(props);
        this.state = {
        }
        themeSettings = getThemeSettingsVariables();
        isUsers = this.checkActivePath("/users");
        isRoles = this.checkActivePath(["/userroles","/adduserrole","/edituserrole"]);
        isDepartments = this.checkActivePath("/userdepartments");
        isDashboardRoles = this.checkActivePath(["/dashboardroles","/adddashboardroles","/editdashboardroles"]);
    }

    checkActivePath = (path) =>{
        themeSettings = getThemeSettingsVariables();
        themeColor = `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},${themeSettings.themeColor.a})`;
       return matchPath(this.props.history.location.pathname, { path });

    }

    userRolesOnClick = () => {
        this.props.setUserRoleFilters("");
        window.location = Constants.URL_USERROLES;
    }

    render(){
        return(
            <TopTabsLayout
            themeSettings={this.props.themeSettings}
            >
                <div className="question-tabs"  style={{marginRight:0}}>
                    <ul style={{width:"50%"}}>
                        <li className={isUsers ? "questiontab-active" : ""}>
                            <a href={Constants.URL_USERLIST}
                                style={{color: !isUsers ? themeColor : '', fontWeight: !isUsers ? "bold" : "100px"}}>Users</a>
                        </li>
                        {hasFeatureAccess(Constants.FEATURE_ROLES) &&
                            <li className={isRoles ? "questiontab-active" : ""}>
                                <a onClick={this.userRolesOnClick} href="javascript:void(0)"
                                    style={{color: !isRoles ? themeColor : '', fontWeight: !isRoles ? "bold" : "100px"}}>Roles</a>
                            </li>
                        }
                        <li className={isDepartments ? "questiontab-active" : ""}>
                            <a href={Constants.URL_USERDEPARTMENTS}
                                style={{color: !isDepartments ? themeColor : '', fontWeight: !isDepartments ? "bold" : "100px"}}>Departments</a>
                        </li>
                        {hasFeatureAccess(Constants.FEATURE_DASHBOARD) && this.props.showDashboardTab &&
                        // this.props.showDashboardTab &&
                            <li className={isDashboardRoles ? "questiontab-active" : ""}>
                                <a href={Constants.URL_DASHBOARD_ROLES}
                                    style={{color: !isDashboardRoles ? themeColor : '', fontWeight: !isDashboardRoles ? "bold" : "100px"}}>Dashboard Roles</a>
                            </li>
                        }
                        {/* <li 
                            className={matchPath(this.props.history.location.pathname, { path: "/managers" }) ? "questiontab-active" : ""}>
                            <a href={Constants.URL_MANAGERS}>Managers</a>
                        </li> */}
                    </ul>
                </div>

                <div style={{opacity:this.props.hideInfo?"0":"1"}} className="infocard-showhide-col">
                    {/* <div className="infocard-icon-col">
                        <img src="/assets/images/topbar-info.svg" />
                    </div> */}
                </div>
            </TopTabsLayout>
        )
    }
}

export default withRouter(connect(null, { setUserRoleFilters })(UserManagementTopMenu));